<template>
	<el-container>
		<el-main style="width: 70%;">
			<div style="margin-bottom: 30px;">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item class="item_font">系统设置</el-breadcrumb-item>
					<el-breadcrumb-item><span class="item_font">推广账号管理</span></el-breadcrumb-item>
				</el-breadcrumb>
			</div>
			<div class="searchBox" style="display: flex;justify-content: flex-end;">
				<el-button type="primary" size="mini" class="item_font" @click='addAduser'>添加账号</el-button>
			</div>
			
			<!--推广账号-->
			<el-table :data="tableData" border style="width: 100%">
				<el-table-column label="序号" type="index" :index="indexMethod" width="60"></el-table-column>
				<el-table-column label="推广账号名">
					<template slot-scope="scope">
						<span>{{scope.row.aduserName}}</span>
					</template>
				</el-table-column>
				<el-table-column label="推广账号ID">
					<template slot-scope="scope">
						<span>{{scope.row.aduserId}}</span>
					</template>
				</el-table-column>
				<el-table-column label="科室">
					<template slot-scope="scope">
						<span>{{scope.row.depName}}</span>
					</template>
				</el-table-column>
			
				<el-table-column prop="createDate" label="添加时间">
				</el-table-column>
				<el-table-column label="操作" align="center" width="200">
					<template slot-scope="scope">
						
						<el-button type="text" size="small" @click="editAduser(scope.$index, scope.row)">编辑账号
						</el-button>
						<el-button type="text" size="small" @click="deleteAduser(scope.$index, scope.row)">删除账号
						</el-button>
					</template>
				</el-table-column>
				<!-- <el-table-column align="center" width="200">
					<template slot="header">
						<el-button type="text" size="small" @click="addAduser">添加账号</el-button>
					</template>
				</el-table-column> -->
			</el-table>
			
			<el-dialog :title="type=='add'?'添加账户':'编辑账户'" center="" width="25%" :visible.sync="dialogVisible" :before-close="closeDialog" :close-on-click-modal="false" :close-on-press-escape="false">
				<el-form label-position="left" label-width="100px" :model="adUserForm" style="margin-left: 30px;margin-right: 30px;">
					<el-form-item label="推广账号名:" prop="aduserName"><el-input v-model="adUserForm.aduserName"></el-input></el-form-item>
					<el-form-item label="推广账号ID:" prop="aduserId" v-if="type=='add'"><el-input v-model="adUserForm.aduserId"></el-input></el-form-item>
					<el-form-item label="科室类型:">
						<el-select v-model="adUserForm.depType" clearable placeholder="请选择 科室类型" style="width: 100%;">
							<el-option v-for="item in depData" :key="item.depType" :label="item.name" :value="item.depType"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="closeDialog">取 消</el-button>
					<el-button type="primary" @click="condirmEditTag">确 定</el-button>
				</span>
			</el-dialog>
			
		</el-main>
	</el-container>
</template>

<script>
	import {MessageBox} from 'element-ui';
	export default {
		data() {
			return {
				tableData: [
				
				],
				editIndex: null,
				type: null,
				// dialogTitle: '添加账号',
				dialogVisible: false,
				adUserForm:{
					aduserName: '',
					aduserId: '',
					id: '',
					depType:'',
				},
				depData:[],
				// rules: {
				// 	aduserName: [
				// 		{required: true, message: '请输入账号名称', trigger: 'blur'}
				// 	],
				// 	aduserId: [
				// 		{required: true, message: '请输入账号ID', trigger: 'blur'}
				// 	]
				// }
			}
		},
		mounted() {
			this.selectList()
		},

		methods: {
			
			indexMethod(index) {
				return index + 1
			},
			editAduser(index, row) {
				console.log(index, row)
				this.type = "edit"
				this.adUserForm.aduserId = row.aduserId
				this.adUserForm.aduserName = row.aduserName
				this.adUserForm.id = row.id
				this.adUserForm.depType = row.depType
				this.dialogVisible = true
				
			},
			deleteAduser(index, row) {
				console.log("this.type",this.type)
				const tipMsg = "是否确认删除该推广账号"
				MessageBox.alert(tipMsg, "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
					showCancelButton: true,
				}).then(async ()=> {
					if(this.type == 'add'){
						this.tableData.splice(index , 1)
						this.type = null
						this.editIndex = null
						this.$message.success("删除成功");
					}else{
						var addApi = "/manager/aduserRelation/del";
						const response = await this.util.postRequest({
							url: addApi,
							method: "POST",
							data: row,
						});
						if (response.resultCode == 10000) {
							this.$message.success("删除成功");
							this.selectList()
						} else {
							this.$message.error(response.desc);
						}
					}
					
					
				}).catch(() => {
					this.$message.info("取消删除");
				})
				
			},
			async confirmAduser() {
				
				var api = this.type == 'add' ? "/manager/aduserRelation/add" : "/manager/aduserRelation/update"
				
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: this.adUserForm,
				});
				
				if (response.resultCode == 10000) {
					const tip = this.type == 'add' ? "新增成功" : "更新成功"
					this.$message.success(tip);
					this.dialogVisible = false
					this.adUserForm = {
						aduserName: '',
						aduserId: '',
						id: ''
					}
					this.selectList()
				} else {
					this.$message.error(response.desc);
				}
				
				// this.type = null				
			},
			// 添加推广账户
			addAduser() {
				this.type = "add"
				this.dialogVisible = true
			},
			async selectList() {
				var api = "/manager/aduserRelation/selectList";
				const response = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {},
				});
				console.log("*****querySelect *****", response);
				if (response.resultCode == 10000) {
					this.tableData = response.data
				} else {
					this.$message.error(response.desc);
				}

				api = "/manager/depType/getDepType";
				const response1 = await this.util.postRequest({
					url: api,
					method: "POST",
					data: {},
				});
				console.log("*****getDepType *****", response1);
				if (response1.resultCode == 10000) {
					this.depData = response1.data
				} else {
					this.$message.error(response1.desc);
				}
			},
			
			// 关闭对话框
			closeDialog(){
				this.dialogVisible = false
				this.adUserForm = {
					aduserName: '',
					aduserId: '',
					id: ''
				}
			},
			
			// 确定编辑或添加
			condirmEditTag(){
				if(this.adUserForm.aduserName.trim() == '' || this.adUserForm.aduserId.trim() == ''){
					this.$message.error('推广账号名称和推广账号ID不能为空，请检查配置')
				}else{
					this.confirmAduser()
					
				}
				
				// this.dialogVisible = false
			}
		},

	}
</script>

<style scoped="scoped">

</style>
